import { colors } from '@globals/themes/defaultTheme'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { SxProps } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import UserAvatar from '@shared/avatar/UserAvatar'
import { fullNameFromParts } from '@shared/utils/nameFormatting'
import { T } from '@transifex/react'

const bannerStyle: SxProps = {
  backgroundColor: colors.greenExtraLight,
  px: 2,
  py: 1,
}

type DelegationBannerProps = {
  delegatorFirstName?: string
  delegatorLastName?: string
  hasBorderRadius?: boolean
}

const DelegationBanner: React.FC<DelegationBannerProps> = ({
  delegatorFirstName,
  delegatorLastName,
  hasBorderRadius = false,
}) => {
  const delegatorFullName = fullNameFromParts(delegatorFirstName, delegatorLastName)

  return (
    <Box sx={{ ...bannerStyle, borderRadius: hasBorderRadius ? '8px' : '0px' }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <UserAvatar firstName={delegatorFirstName} lastName={delegatorLastName} size={36} />
        <Typography variant="body1" sx={{ color: colors.greenDark }}>
          <T _str="You're sending on behalf of {name}" name={<b>{delegatorFullName}</b>} />
        </Typography>
      </Stack>
    </Box>
  )
}

export default DelegationBanner
